module.exports = __webpack_public_path__ + "img/step_2.1acdf255.png";